import { handleActions } from 'redux-actions';
import { dialogChangeParentMapping, dialogLoadMappingsUsed } from '../actions';

const initialState = {
    parentMapping: '',
    mappingsUsed: [],
};

export default handleActions(
    {
        [dialogChangeParentMapping]: (state, action) => ({
            ...state,
            parentMapping: action.payload,
        }),
        [dialogLoadMappingsUsed]: (state, action) => ({
            ...state,
            mappingsUsed: action.payload,
        }),
    },
    initialState,
);
